/**
 * ローカルストレージclass
 */
export default class LocalStorage {
    /**
     * コンストラクタ
     */
    constructor(config, keySuffix = '') {
        const { id, name } = config;

        /** @property {string} storageKey localStorageのキー */
        this.storageKey = `habits_game_${keySuffix || `${id}_${name}`}`;

        /** @property {object} storageValue localStorageの値 */
        this.storageValue = this.getStorageValue(this.storageKey);
    }

    /**
     * localStorageの値を取得
     *
     * @param {string} storageKey localStorageのキー
     */
    getStorageValue(storageKey) {
        try {
            const storageValue = window.localStorage.getItem(storageKey);

            if (!storageValue) {
                window.localStorage.setItem(storageKey, '{}');
                return {};
            }

            return JSON.parse(storageValue);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }

        return {};
    }

    /**
     * セット
     *
     * @param {string} key キー
     * @param {stringify} value 値
     */
    set(key, value) {
        this.storageValue[key] = value;

        try {
            window.localStorage.setItem(this.storageKey, JSON.stringify(this.storageValue));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }

    /**
     * 取得
     * @param {string} key キー
     */
    get(key) {
        return key in this.storageValue
            ? this.storageValue[key]
            : null;
    }
}
